<template>
    <div class="camera-modal">
        <h3 class="map-modal__title">{{ title }}</h3>
        <div
            v-for="link in cameraLinks"
            :key="'camera-' + link"
            class="map-modal__image mt-2"
            :style="`background-image:url(${link})`"
        ></div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
        },
        image: {
            type: String,
            default: "",
        },
        cameraLinks: {
            default: () => [],
        },
    },
    data() {
        return {};
    },
};
</script>
